import { useEffect, useRef } from 'react';
import { trackEvent } from '../hooks/useSiteTooling';

const DEPTHS = [25, 50, 75, 100];

export const ScrollTracker = () => {
  const tracked = useRef(new Set());

  useEffect(() => {
    tracked.current = new Set();

    const handleScroll = () => {
      const pct = Math.round(
        ((window.scrollY + window.innerHeight) / document.body.scrollHeight) * 100
      );
      DEPTHS.forEach((depth) => {
        if (pct >= depth && !tracked.current.has(depth)) {
          tracked.current.add(depth);
          trackEvent('page_scroll', { depth_percent: depth });
        }
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return null;
};
